<template>
 <v-card flat >
   <v-layout row>
    <v-flex md5>
      <empresas class="ml-4 pl-3 mr-1" v-on:empresa-select="getEmpresa"></empresas>
    </v-flex>
     <v-flex md4>
      <unidade class="ml-1" :mEmpresa="empresa" v-on:get-unidade="getUnidade"></unidade>
    </v-flex>
    <v-flex md3 class="pl-1 pr-8">
       <v-select
          :items="anos"
          v-model="ano"
          label="Selecione o ano"
        ></v-select>
    </v-flex>
    <v-flex md12>
      <div class="px-4" v-if="load">
        <v-skeleton-loader
        ref="skeleton"
        type="list-item"
        class="mx-auto"
      ></v-skeleton-loader>
       <v-skeleton-loader
        ref="skeleton"
        type="list-item"
        class="mx-auto"
      ></v-skeleton-loader> <v-skeleton-loader
        ref="skeleton"
        type="list-item"
        class="mx-auto"
      ></v-skeleton-loader> <v-skeleton-loader
        ref="skeleton"
        type="list-item"
        class="mx-auto"
      ></v-skeleton-loader>
      </div>
      <v-list-item
          v-if="isEdit"
          dense>
            <v-flex md2 class="ml-3">
            <div v-html="'Meta anual'" class="title primary--text"></div>
            </v-flex>
             <v-flex md5 class="mr-2">
            <v-text-field
              :disabled="!isEdit"
              label="Valor minimo"
              required
              v-model="metaAnual.valorMinimo"
              v-money="money"
              :loading="load"
            ></v-text-field>
             </v-flex>
             <v-flex md5 class="pr-4">
            <v-text-field
            :disabled="!isEdit"
              label="Valor meta"
              v-model="metaAnual.valorMeta"
              v-money="money"
              :loading="load"
              required
            ></v-text-field>
             </v-flex>
        </v-list-item>
        <v-divider class="mx-3"></v-divider>
      <v-list-item
          :disabled="!isEdit"
          dense
          v-for="mes in mesesAux"
          :key="mes.id">
          <!-- <v-list-item-avatar>
            <v-img :src="item.avatar"></v-img>
          </v-list-item-avatar> -->

            <v-flex md2 class="ml-3">
            <div v-html="mes.nome" class="title"></div>
            </v-flex>
             <v-flex md5 class="mr-2">
            <v-text-field
              :disabled="!isEdit"
              label="Valor minimo"
              required
              v-model="mes.valorMinimo"
              v-money="money"
              :loading="load"
            ></v-text-field>
             </v-flex>
             <v-flex md5 class="pr-4">
            <v-text-field
            :disabled="!isEdit"
              label="Valor meta"
              v-model="mes.valorMeta"
              v-money="money"
              :loading="load"
              required
            ></v-text-field>
             </v-flex>
        </v-list-item>
    </v-flex>
   </v-layout>
   <v-card-actions>
     <v-spacer></v-spacer><v-btn :loading="load" :disabled="mesesAux.length <= 0" color="primary" @click="cadastrarMetas"><v-icon>save</v-icon> Salvar</v-btn>
   </v-card-actions>
   <notifications group="alert" position="bottom left" />
  </v-card>
</template>

<script>
import empresas from '../filtros/components/empresas'
import unidade from '../filtros/components/unidade'
import service from '../../services/metaservice'
import { VMoney } from 'v-money'

export default {
  name: 'ajustesFaturamento',
  components: {
    empresas,
    unidade
  },
  directives: { money: VMoney },
  data: () => ({
    empresa: null,
    mUnidade: {
      id: 0
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    ano: null,
    metaAnual: {
      valorMeta: '',
      valorMinimo: ''
    },
    isEdit: false,
    load: false,
    mesesAux: [],
    anos: [
      2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
  }),
  methods: {
    getEmpresa (data) {
      this.empresa = data
    },
    getUnidade (data) {
      this.mUnidade = data
    },
    carregarDados () {
      // eslint-disable-next-line no-mixed-operators
      if ((this.empresa !== null && this.ano != null) || (this.mUnidade.nome !== null && this.ano != null)) {
        this.load = true
        this.mesesAux = []
        service.listarMetas({
          idEmpresa: this.empresa.id,
          idUnidade: this.mUnidade.id,
          dataInicial: `${this.ano}-0-0`,
          dataFinal: '0' }).then(r => {
          if (r.status === 200) {
            if (r.data.status === 1) {
              if (r.data.empresa.anos.length > 0) {
                let meta = r.data.empresa.anos[0]
                this.metaAnual.valorMeta = meta.valorMeta
                this.metaAnual.valorMinimo = meta.valorMinimo
                this.carregarMeses(meta.meses)
              }
            } else {
              this.mesesAux = this.getMeses()
              this.isEdit = true
            }
          }
        }).finally(r => {
          this.load = false
        })
      }
    },
    cadastrarMetas () {
      service.cadastrarMeta({
        idEmpresa: this.empresa.id,
        idUnidade: this.mUnidade.id,
        date: `${this.ano}-0-0`,
        meses: this.mesesAux,
        metaAnual: {
          valorMeta: this.metaAnual.valorMeta,
          valorMinimo: this.metaAnual.valorMinimo
        } }).then(r => {
        if (r.status === 200) {
          this.$notify({
            group: 'alert',
            type: 'success',
            title: 'Cadastro',
            text: 'Dados atualizados com sucesso'
          })
        }
      })
    },
    carregarMeses (mMeses) {
      for (let i = 0; i < mMeses.length; i++) {
        let m = mMeses[i]
        let meses = this.getMeses()
        for (let j = 0; j < meses.length; j++) {
          const mMes = meses[j]
          if (mMes.mes === m.mes) {
            mMes.valorMinimo = m.valorMinimo
            mMes.valorMeta = m.valorMeta
            this.mesesAux.push(mMes)
          }
        }
      }
      this.isEdit = true
    },
    getMeses () {
      return [
        { mes: 1,
          nome: 'Janeiro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 2,
          nome: 'Fevereiro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 3,
          nome: 'Março',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 4,
          nome: 'Abril',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 5,
          nome: 'Maio',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 6,
          nome: 'Junho',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 7,
          nome: 'Julho',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 8,
          nome: 'Agosto',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 9,
          nome: 'Setembro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 10,
          nome: 'Outubro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 11,
          nome: 'Novembro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 12,
          nome: 'Dezembro',
          valorMinimo: '',
          valorMeta: '' }
      ]
    }
  },
  watch: {
    empresa (val) {
      this.carregarDados()
    },
    mUnidade (val) {
      this.carregarDados()
    },
    ano (val) {
      this.carregarDados()
    }
  },
  mounted () {
  }
}
</script>
